import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingPage } from '@components/LoadingPage';
import { useAuth } from '../context/AuthContext';
import { ROOT_PATH } from '../paths';

export const IsAuthenticated = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isAuthenticated) {
    const { pathname, search } = location;
    const hasPathname = pathname && pathname !== ROOT_PATH;
    const hasQueryParams = !!location.search;
    if (hasPathname || hasQueryParams) {
      const returnToQueryParam = `returnTo=${encodeURIComponent(pathname + search)}`;
      return <Navigate to={`${ROOT_PATH}?${returnToQueryParam}`} />;
    }

    return <Navigate to={ROOT_PATH} />;
  }

  return <Outlet />;
};
